module.exports = __webpack_public_path__ + "img/Dantam Makeover 10.6708bb80.jpg";